import React, { useState, useContext } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  Link,
  Alert,
} from '@mui/material';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Telegram } from '@mui/icons-material';

const Register: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setError('');

  if (!email) {
    setError('Email обязателен');
    return;
  }

  if (!agreed) {
    setError('Необходимо принять пользовательское соглашение');
    return;
  }

  try {
    await auth?.register(username, password, email);
    navigate('/profile');
  } catch (err: any) {

    if (err.response?.status === 409) {
      setError('Пользователь с таким логином или email уже существует');
      return;
    }

    if (err.response?.status === 422) {
      setError('Ошибка валидации данных');
      return;
    }

    setError('Ошибка регистрации. Попробуйте позже.');
  }
};

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Typography
        variant="h4"
        sx={{
          textAlign: 'center',
          color: '#1E3A8A',
          fontWeight: 800,
          mb: 5,
          fontSize: { xs: '2rem', md: '2.5rem' },
        }}
      >
        Создать аккаунт
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <TextField
          label="Логин"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          required
          variant="outlined"
          sx={{ mb: 2 }}
        />

        <TextField
          label="Пароль"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          required
          variant="outlined"
          sx={{ mb: 2 }}
        />

        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          variant="outlined"
          helperText="Для восстановления пароля и уведомлений"
          sx={{ mb: 3 }}
        />

        {/* Галочка согласия */}
        <FormControlLabel
          control={
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              color="primary"
              required
            />
          }
          label={
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Я принимаю{' '}
              <Link
                component={RouterLink}
                to="/terms"
                target="_blank"
                rel="noopener"
                sx={{
                  color: '#60A5FA',
                  fontWeight: 600,
                  textDecoration: 'underline',
                  '&:hover': { color: '#3B82F6' },
                }}
              >
                пользовательское соглашение (публичную оферту)
              </Link>{' '}
              и{' '}
              <Link
                component={RouterLink}
                to="/privacy"
                target="_blank"
                rel="noopener"
                sx={{
                  color: '#60A5FA',
                  fontWeight: 600,
                  textDecoration: 'underline',
                  '&:hover': { color: '#3B82F6' },
                }}
              >
                политику конфиденциальности
              </Link>
            </Typography>
          }
          sx={{ mb: 3, alignItems: 'flex-start', '& .MuiSvgIcon-root': { fontSize: 20 } }}
        />
        <Box sx={{ bgcolor: '#F0F9FF', border: '1px solid #BAE6FD', borderRadius: 3, p: 3, mb: 4, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#0369A1', fontWeight: 600, mb: 1 }}>
            Поддержка и восстановление пароля — через Telegram
          </Typography>
          <Typography variant="body2" sx={{ color: '#0C4A6E', mb: 2 }}>
            Все уведомления, восстановление доступа и помощь — в одном клике
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<Telegram sx={{ fontSize: 20 }} />}
            href="https://t.me/tg_typhon_bot"
            target="_blank"
            sx={{
              bgcolor: '#229ED9',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              '&:hover': { bgcolor: '#1C86B8' },
            }}
          >
            @tg_typhon_bot — авторизируйтесь после регистрации!
          </Button>
          <Typography variant="caption" sx={{ display: 'block', mt: 1.5, color: '#0369A1' }}>
            Сохраните контакт — пригодится при восстановлении пароля
          </Typography>
        </Box>
        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          disabled={!username || !password || !email || !agreed}
          sx={{
            bgcolor: '#1E3A8A',
            color: 'white',
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 700,
            borderRadius: 3,
            '&:hover': { bgcolor: '#1E40AF' },
            '&:disabled': {
              bgcolor: '#9CA3AF',
              color: '#E5E7EB',
            },
          }}
        >
          Зарегистрироваться
        </Button>

        <Typography variant="body2" sx={{ textAlign: 'center', mt: 3, color: 'text.secondary' }}>
          Уже есть аккаунт?{' '}
          <Link
            component={RouterLink}
            to="/login"
            sx={{ color: '#60A5FA', fontWeight: 600, textDecoration: 'underline' }}
          >
            Войти
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Register;